import { Button, Form, Table } from 'react-bootstrap'
import { Download, Search } from 'lucide-react'
import Loader from '../../../../components/atoms/Loader'
import RowEmpty from '../../../../components/atoms/RowEmpty'
import TablePagination from '../../../../components/atoms/Table/TablePagination'

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const StockTable = ({
  columns,
  stocks,
  loading,
  type,
  selectedID,
  handleChangeCheckbox,
  meta,
  handlePageChange,
  handleOnChangeMeta,
  downloadingRows,
  handleDownloadLabel,
  handleRedirectPageQuarantineReject,
  handleDetail
}) => {
  const renderActionStockNormal = (data) => (
    <div key={data.item_id}>
      <button
        className="btn btn-secondary rounded d-flex align-items-center justify-content-center"
        style={{ width: '32px', height: '32px', padding: 0 }}
        onClick={() => handleDetail(data.item_id)}
        title="View Detail"
      >
        <Search size={16} />
      </button>
    </div>
  )

  const renderActionStockQuarantineOrReject = (data) => (
    <div className="d-flex flex-row gap-2 justify-content-end">
      <Button
        variant={downloadingRows[data.slot_item_id] ? 'secondary' : 'warning'}
        className="rounded d-flex align-items-center justify-content-center p-0"
        style={{ width: '32px', height: '32px' }}
        onClick={() => handleDownloadLabel(data.slot_item_id)}
        disabled={downloadingRows[data.slot_item_id]}
        title="Download Label"
      >
        <Download className="text-white" size={16} />
      </Button>
      <button
        className="btn btn-secondary rounded d-flex align-items-center justify-content-center p-0"
        style={{ width: '32px', height: '32px' }}
        disabled={downloadingRows[data.slot_item_id]}
        onClick={() =>
          handleRedirectPageQuarantineReject(
            data.slot_item_id,
            type === 'rejected' ? 'reject' : type
          )
        }
        title="View Detail"
      >
        <Search size={16} />
      </button>
    </div>
  )

  return (
    <Table
      hover
      responsive
      className="shadow-sm mb-5 bg-white"
      style={{
        borderRadius: '12px',
        overflow: 'hidden',
        fontSize: '0.9rem'
      }}
    >
      <thead style={{ backgroundColor: '#f8f9fa' }}>
        <tr>
          {columns.map((column) => (
            <th
              className={`p-2 align-middle ${column.className || ''}`}
              key={column.key}
              width={column.width}
              style={tableHeaderStyle}
            >
              {column.key === 'checkbox' ? (
                <Form.Check
                  type="checkbox"
                  checked={
                    stocks?.length !== 0 && stocks?.length === selectedID.length
                  }
                  disabled={!stocks?.length}
                  onChange={() => handleChangeCheckbox()}
                />
              ) : (
                column.label
              )}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {loading && (
          <tr>
            <td colSpan={columns.length} className="p-3 text-center">
              <Loader />
            </td>
          </tr>
        )}
        {!loading && stocks.length === 0 && (
          <RowEmpty colSpan={columns.length} />
        )}
        {!loading &&
          stocks.length > 0 &&
          stocks.map((stock, indexStock) => (
            <tr key={indexStock} style={{ borderBottom: '1px solid #f0f0f0' }}>
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={`p-2 align-middle ${column.className || ''}`}
                >
                  {column.key === 'checkbox' && (
                    <Form.Check
                      type="checkbox"
                      value={stock?.slot_item_id || stock?.id || ''}
                      checked={
                        !!selectedID.find(
                          (selectId) =>
                            selectId.id === (stock?.slot_item_id || stock?.id)
                        )
                      }
                      disabled={
                        (type === 'vas' && stock.workorder_type !== 'repack') ||
                        (type === 'staging' && stock.staging_type === 'inbound')
                      }
                      onChange={() =>
                        handleChangeCheckbox({
                          id: stock?.slot_item_id || stock?.id,
                          problem: stock?.item_problem
                        })
                      }
                    />
                  )}
                  {column.key === 'action' &&
                    (type === 'quarantine' || type === 'rejected'
                      ? renderActionStockQuarantineOrReject(stock)
                      : renderActionStockNormal(stock))}
                  {column.component && column.component(stock)}
                  {column.key !== 'checkbox' &&
                    column.key !== 'action' &&
                    !column.component &&
                    (stock[column.key] ?? '-')}
                </td>
              ))}
            </tr>
          ))}
      </tbody>
      <tfoot>
        <tr>
          <td className="p-3 border-top-0" colSpan={columns.length}>
            <TablePagination
              meta={meta}
              handlePageChange={handlePageChange}
              handleOnChangeMeta={handleOnChangeMeta}
            />
          </td>
        </tr>
      </tfoot>
    </Table>
  )
}

export default StockTable
